module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div class=\"row\">\n	<div><label>Разделитель колонок</label></div>\n	<select name=\"options[delimiter]\">\n		<option value=\"comma\">запятая</option>\n		<option value=\"semicolon\">точка с запятой</option>\n		<option value=\"tab\">табуляция</option>\n	</select>\n</div>\n\n<div class=\"row\">\n	<div><label>Действие с существующими записями</label></div>\n	<select name=\"options[existing]\">\n		<option value=\"update\">Обновлять</option>\n		<option value=\"skip\">Пропускать</option>\n	</select>\n</div>\n")
  }
  return __output.join("");

}